import { cn } from '@/lib/utils'

type Props = {
  nickname: string
  avatarUrl?: string
  size?: number
  className?: string
}

/** フレンドのアバター。画像があれば表示、無ければニックネーム先頭文字の丸。 */
export default function FriendAvatar({ nickname, avatarUrl, size = 40, className }: Props) {
  const initial = nickname?.trim()?.[0] ?? '?'
  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-muted text-muted-foreground font-medium',
        className,
      )}
      style={{ width: size, height: size, fontSize: size * 0.4 }}
    >
      {avatarUrl ? (
        <img src={avatarUrl} alt={nickname} className="h-full w-full object-cover" />
      ) : (
        <span>{initial}</span>
      )}
    </div>
  )
}
